import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import { DatabaseValue } from "../../../contexts/database";
import { UserValue } from "../../../contexts/user";
import { renameField, deleteField } from "../../../utils/databaseactions";
import { useParams } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { useQuery, useQueryClient } from "react-query";
import Modal from "../../../modal";
import AddField from "./addField";
import Field from "./field";

export default function Fields({ id, open, tableId }) {
  const [selectedFieldName, setSelectedFieldName] = useState("");
  const [selectedFieldID, setSelectedFieldID] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [table, setTable] = useState(null);
  const context = useContext(DatabaseValue);
  const user = useContext(UserValue);
  const { appId } = useParams();
  const queryClient = useQueryClient()

  const { data, error, isLoading, isError, refetch } = useQuery(
    ["tableFields", tableId],
    () => {
      return new Promise((resolve, reject) => {
        const t = context[id];
        if (!!t) {
          const fieldIds = Object.keys(t.fields);
          fieldIds.splice(fieldIds.indexOf("_id"), 1);
          const sortedIds = fieldIds.sort((a, b) => {
            const nameA = t.fields[a].name.toLowerCase();
            const nameB = t.fields[b].name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          sortedIds.unshift("_id");
          resolve(sortedIds);
        } else reject("table is not defined yet");
      });
    },
    { staleTime: 60000, enabled: false }
  );

  useEffect(() => {
    setTable(context[id] || null);
  }, [id, context]);

  useEffect(() => {
    if (!!table) refetch();
  }, [table]);

  useEffect(() => {
    if (!modalIsOpen) {
      setFnIsRunning(false);
      setSelectedFieldName("");
      setSelectedFieldID("");
    }
  }, [modalIsOpen]);

  const handleRename = (fieldId, newName) => {
    const action = renameField(appId, table.id, fieldId, newName);
    action.then((d) => console.log(d)).catch((e) => console.log(e));
  };

  const handleDelete = (fieldId) => {
    setSelectedFieldID(fieldId);
    setSelectedFieldName(table.fields[fieldId].name);
    setModalIsOpen(true);
  };

  const _deleteField = () => {
    setFnIsRunning(true);
    const action = deleteField(appId, table.id, selectedFieldID, user);
    action
      .then((data) => {
        if (data.err) throw new Error(data.err);
        refetch();
        console.log("field deleted");
      })
      .catch((err) => console.log(err))
      .finally(() => setModalIsOpen(false));
  };

  const renderFields = () => {
    if (!table) return null;
    if (isError) return <div>Error: {error.message}</div>;
    if (isLoading) return <div>Loading</div>;

    return (data || []).map((fieldId) => {
      if (!table.fields[fieldId]) return null;
      return (
        <Field
          table={id}
          field={table.fields[fieldId]}
          id={fieldId}
          key={`${table.id}.${fieldId}`}
          rename={handleRename}
          handleDelete={handleDelete}
        />
      );
    });
  };

  if (!open || !table) return null;
  return (
    <div className={styles.section}>
      <div className={styles.table}>
        <Modal onClose={() => setModalIsOpen(false)} open={modalIsOpen}>
          <div className={styles.form}>
            {fnIsRunning ? (
              <div className={styles.formContainer}>
                <div className={styles.text}>
                  Deleting {selectedFieldName} Field
                </div>
              </div>
            ) : (
              <>
                <div className={styles.formTitle}>
                  Delete Field{" "}
                  <MdClose
                    onClick={() => setModalIsOpen(false)}
                    className="icon"
                  />
                </div>
                <div className={styles.formContainer}>
                  <div
                    className={styles.text}
                    style={{ textAlign: "center", marginBottom: 15 }}
                  >
                    Are you sure you? This can't be undone...
                  </div>
                  <button className={styles.save} onClick={_deleteField}>
                    Yes, delete {selectedFieldName}
                  </button>
                  <button
                    className={styles.clear}
                    onClick={() => setModalIsOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal>
        <div className={styles.grid}>
          <div>Field Name</div>
          <div>Field Type</div>
          <div>List</div>
          <div></div>
        </div>
        <ul>{renderFields()}</ul>
        <AddField id={id} table={table} update={() => queryClient.invalidateQueries('tableFields')} />
      </div>
    </div>
  );
}
